function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import moment from "moment";
import { DatePicker, Space, Table, Button, Tabs } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { Excel } from "antd-table-saveas-excel";
import Moment from "react-moment";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var TabPane = Tabs.TabPane;
var SettlementHistory = function SettlementHistory(_ref) {
  var _ref$bill = _ref.bill,
    bill = _ref$bill === void 0 ? null : _ref$bill;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    settlements = _useState4[0],
    setSettlements = _useState4[1];
  var cols = [{
    title: "Date",
    dataIndex: "date",
    render: function render(date) {
      return /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY HH:mm",
        date: date
      });
    },
    key: "date"
  }, {
    title: "Montant",
    dataIndex: "amount",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "amount"
  }, {
    title: "Agent",
    dataIndex: "user",
    render: function render(text) {
      return /*#__PURE__*/_jsx("b", {
        children: text
      });
    },
    key: "user"
  }];
  var handleExport = function handleExport() {
    var excel = new Excel();
    excel.addSheet("sheet").addColumns(cols).addDataSource(settlements, {
      str2Percent: true
    }).saveAs("exp.xlsx");
  };
  useEffect(function () {
    if (bill == null || bill == 'undefined') return;
    bill.bill_settlements.forEach(function (s) {
      setSettlements(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          date: s.created_at,
          amount: s.amount,
          user: s.user.prenom + " " + s.user.nom
        }]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          children: /*#__PURE__*/_jsx(Table, {
            size: "small",
            columns: cols,
            bordered: true,
            loading: isDataLoading,
            dataSource: settlements,
            pagination: true
          })
        })
      })
    })
  });
};
export default SettlementHistory;